import http from "@/settings/apiSettings";

class ADServices {
  // --- AD Users ---
  getUsers(): Promise<any> {
    return http.clientAuth.get("/AD/GetUsers");
  }
    // --- Generate AD Account ---
  generateAccount(email: string, username: string): Promise<any> {
    return http.clientAuth.post("/AD/GenerateAccount", { email, username });
  }

  // --- AD Settings ---
  getSettings(): Promise<any> {
    return http.clientAuth.get("/AD/GetSettings");
  }

  getSettingById(id: string): Promise<any> {
    return http.clientAuth.get(`/AD/GetSettings/${id}`);
  }

  createSetting(data: any): Promise<any> {
    return http.clientAuth.post("/AD/CreateSettings", data);
  }

  updateSetting(id: string, data: any): Promise<any> {
    return http.clientAuth.put(`/AD/UpdateSettings/${id}`, data);
  }

  deleteSetting(id: string): Promise<any> {
    return http.clientAuth.delete(`/AD/DeleteSettings/${id}`);
  }

    // --- ERP Companies ---
  getCompanies(): Promise<any> {
    return http.clientAuth.get("/AD/GetCompanies");
  }

  getCompanyById(id: string): Promise<any> {
    return http.clientAuth.get(`/AD/GetCompany/${id}`);
  }

  createCompany(data: any): Promise<any> {
    return http.clientAuth.post("/AD/CreateCompany", data);
  }

  updateCompany(id: string, data: any): Promise<any> {
    return http.clientAuth.put(`/AD/UpdateCompany/${id}`, data);
  }

  deleteCompany(id: string): Promise<any> {
    return http.clientAuth.delete(`/AD/DeleteCompany/${id}`);
  }
}

export default new ADServices();
